import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});
